import { render, staticRenderFns } from "./UserCenter.vue?vue&type=template&id=3b8e2d16&scoped=true&"
import script from "./UserCenter.vue?vue&type=script&lang=js&"
export * from "./UserCenter.vue?vue&type=script&lang=js&"
import style0 from "./UserCenter.vue?vue&type=style&index=0&id=3b8e2d16&lang=less&scoped=true&"
import style1 from "./UserCenter.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8e2d16",
  null
  
)

export default component.exports